import moment from "moment";
import { DateTime } from 'luxon';

export function formatDateTimeForInput(datetime) {
  if (!datetime) { return null; }
  let newDateTime = moment(datetime).format('YYYY-MM-DD\THH:mm')
  return newDateTime;
}

export function formatDateForInput(date) {
  if (!date) { return null; }
  let newDate = moment(date).format('YYYY-MM-DD')
  return newDate;
}

export function formatTimeForInput(time) {
  if (!time) { return null; }
  let newTime = moment(time, "HH:mm").format('HH:mm')
  return newTime;
}

export const dateShort = value => {
  if (value.value) { value = value.value; }
  if (!value || value.entry) { return null; }

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATE_SHORT)
};

export const datetimeShort = value => {
  if (value.value) { value = value.value; }
  if (!value || value.entry) { return null; }

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATETIME_SHORT)
};

export const datetimeWithAge = value => {
  if (value?.value) { value = value.value; }
  if (!value || value.entry) { return null; }

  return `${datetimeShort(value)} (${DateTime.fromISO(value).toRelative()})`;
};
